// =============================================================================
//  KOMPONENTE: PlayerList
// =============================================================================
//  Zweck: Stellt eine Liste von Spielern in einer Tabelle dar.
// =============================================================================
import React from 'react';

const PlayerList = ({ players, onEdit, onDelete }) => {
  return (
    <div className="table-container">
      <h3>Bestehende Spieler</h3>
      <table>
        <thead>
          <tr>
            <th>Nachname</th>
            <th>Vorname</th>
            <th>Verein</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {players.length > 0 ? (
            players.map((player) => (
              <tr key={player._id}>
                <td>{player.lastName}</td>
                <td>{player.firstName}</td>
                {/* Zeige den Vereinsnamen an. Sicherheitscheck für den Fall, dass kein Verein verknüpft ist. */}
                <td>{player.club ? player.club.name : 'N/A'}</td>
                <td>
                  <button className="btn-edit" onClick={() => onEdit(player)}>
                    Bearbeiten
                  </button>
                  <button className="btn-delete" onClick={() => onDelete(player._id)}>
                    Löschen
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4">Noch keine Spieler angelegt.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PlayerList;